import { useRef, useEffect } from 'react';
import { createRoot } from 'react-dom/client';

type Props = {
  map: any;
  position: google.maps.LatLngLiteral;
  onClick: () => void;
  children: React.ReactElement;
  isActive?: boolean;
};

export function MarkerWrapper({ map, position, children, onClick, isActive }: Props) {
  const rootRef = useRef<any>();
  const markerRef = useRef<any>();

  useEffect(() => {
    if (!rootRef.current) {
      const container = document.createElement('div');

      rootRef.current = createRoot(container);

      markerRef.current = new google.maps.marker.AdvancedMarkerElement({
        position,
        content: container,
        zIndex: isActive ? 99999 : 0,
      });
    }

    return () => {
      markerRef.current.map = null;
    };
  }, []);

  useEffect(() => {
    rootRef.current.render(children);
    markerRef.current.position = position;
    markerRef.current.map = map;

    // Handle both click and touch events
    const clickListener = markerRef.current.addListener('click', onClick);
    const touchListener = markerRef.current.addListener('touchstart', onClick);

    return () => {
      clickListener.remove();
      touchListener.remove();
    };
  }, [map, position, children, onClick]);

  return null;
}
